import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scrolls to the top whenever the page (route) changes, so new pages open from the start. */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
